// Spanish quiz (web47_spanish_quiz): i18next setup. Every user-facing string
// lives in src/locales/<lng>/<area>.json; see src/locales/README.md.
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { resources } from "./resources";

export type QuizLanguage = "en" | "es";

// Test builds (REACT_APP_I18N_STRICT=true) have no English fallback and throw
// on a missing key, so the E2E walk fails on any untranslated string.
export const I18N_STRICT = process.env.REACT_APP_I18N_STRICT === "true";

export function reportMissingKey(lng: string, key: string): void {
  // The E2E walker collects this console line.
  console.error(`i18n missing key: ${lng} ${key}`);
  if (I18N_STRICT) throw new Error(`i18n missing key: ${lng} ${key}`);
}

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: I18N_STRICT ? false : "en",
  supportedLngs: ["en", "es"],
  interpolation: { escapeValue: false },
  returnNull: false,
  react: { useSuspense: false },
  saveMissing: true,
  missingKeyHandler: (lngs, _ns, key) => {
    lngs.forEach((lng) => reportMissingKey(lng, key));
  },
});

export default i18n;
